var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01Inform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5018 0.000549316C115.644 0.000549316 149 33.3543 149 74.5C149 115.647 115.644 148.999 74.5018 148.999C33.3561 148.999 0 115.647 0 74.5C0 33.3543 33.3561 0.000549316 74.5018 0.000549316Z",
    fill: "url(#paint0_linear_1_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5006 73.2023C62.4693 73.2023 52.6785 63.4139 52.6785 51.3813C52.6785 39.3476 62.4693 29.5592 74.5006 29.5592C86.532 29.5592 96.3216 39.35 96.3216 51.3813C96.3216 63.4127 86.532 73.2023 74.5006 73.2023ZM112.943 100.149L112.634 100.517C102.466 112.717 88.9211 119.442 74.5006 119.442C60.079 119.442 46.5343 112.719 36.3652 100.517L36.0564 100.149L36.1271 99.673C38.093 86.8625 44.7817 76.5696 54.9744 70.6906L55.7004 70.2723L56.278 70.8769C61.0914 75.9238 67.5632 78.7053 74.5006 78.7053C81.4379 78.7053 87.911 75.9238 92.7244 70.8769L93.302 70.2723L94.028 70.6906C104.216 76.572 110.909 86.8649 112.875 99.673L112.943 100.149ZM76.1154 89.8904L79.7172 86.285L74.5006 81.0673L69.2828 86.285L72.8847 89.888L69.2828 109.576L74.5006 114.798L79.7172 109.579L76.1154 89.8904Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16",
    x1: 127.178,
    y1: 127.179,
    x2: 21.8221,
    y2: 21.8215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE620"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Inform);
export default __webpack_public_path__ + "static/media/01_inform.2323ded2d8caf8475933df8ad34a7ed7.svg";
export { ForwardRef as ReactComponent };